import { useState } from "react";
import cn from "clsx";
import { PrismicNextImage } from "@prismicio/next";
import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { TitlePage } from "@components/commun";
import style from "./RecommandationsOptimum.module.scss";

export type RecommandationsOptimumProps =
  SliceComponentProps<Content.RecommandationsOptimumSlice>;

const RecommandationsOptimum = ({
  slice,
}: RecommandationsOptimumProps): JSX.Element => {
  const [active, setActive] = useState(-1);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={style.section}
    >
      <div className={style.title}>
        <TitlePage>
          <PrismicRichText field={slice.primary.title} />
        </TitlePage>
      </div>
      <div className="lk-wrap">
        <div className="lk-wrap-content">
          <div className={style.content}>
            <div className="lk-flex lk-flex-mob-colomn space-between">
              <div
                className={cn(style.left, {
                  [style.active]: active === 1,
                })}
                role="presentation"
                onClick={() => setActive(active === 1 ? -1 : 1)}
              >
                <div className={style.title}>
                  <PrismicRichText field={slice.primary.titleLeft} />
                </div>
                <PrismicNextImage field={slice.primary.imageLeft} />
                <div className={style.description}>
                  <PrismicRichText field={slice.primary.descriptionLeft} />
                </div>
              </div>
              <div
                className={cn(style.right, {
                  [style.active]: active === 2,
                })}
                role="presentation"
                onClick={() => setActive(active === 2 ? -1 : 2)}
              >
                <div className={style.title}>
                  <PrismicRichText field={slice.primary.titleRight} />
                </div>
                <PrismicNextImage field={slice.primary.imageRight} />
                <div className={style.description}>
                  <PrismicRichText field={slice.primary.descriptionRight} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecommandationsOptimum;
